/**
 * @author Sirisha.M
 * @description 
 */
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import '../../CSS/CounterList.css';
import { connect } from 'react-redux';
import { config } from '../../constant';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { API_TRENDS } from '../../../../../commons/api';
import { List, Card, Tag, Modal, Button, Row } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { tableTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
// import _ from 'lodash';

const CardsList = (props) => {
  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    translationCache,
    currentTimeZone,
  } = props;

  const getOption = () => {
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        json: []
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            title: 'download',
            name: graphprops && graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        json: []
      },
      yAxis: {
        type: 'value'
      },
      series: []
    };
    return option;
  };
  const [cardsList, setCardsList] = useState([]);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [last30Records, setLast30Records] = useState(false);
  const [option, setOption] = useState(getOption());
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());






  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {

      if (
        graphprops &&
        graphprops[graphprops.graph] &&
        graphprops[graphprops.graph].show30minsData &&
        graphprops[graphprops.graph].show30minsData === 'true'
      ) {
        getLast30minsData();
      }
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    translationCache
  ]);

  const getLast30minsData = () => {
    let payload = {
      Type: 'live',
      ViewType: 'Single',
      GraphType: 'line',
      ParameterList: [
        {
          ParameterCode: 'Brake_Status_Motoring',
          DeviceCode: 'BECU_12',
          TableName: 'OnChange',
          parameterType: 'OnChange',
          parameterDescription: '-',
          parameterName: 'Drive Speed Command',
          deviceName: 'Brake_Electronic_Control_Unit'
        },
        {
          ParameterCode: 'Brake_Status_Motoring',
          DeviceCode: 'BECU_19',
          TableName: 'OnChange',
          parameterType: 'OnChange',
          parameterDescription: '-',
          parameterName: 'Drive Output Voltage',
          deviceName: 'Brake_Electronic_Control_Unit'
        },
        {
          ParameterCode: 'Brake_Status_Coasting',
          DeviceCode: 'BECU_1',
          TableName: 'OnChange',
          parameterType: 'OnChange',
          parameterDescription: '-',
          parameterName: 'Motor Speed Status',
          deviceName: 'Brake_Electronic_Control_Unit'
        }
      ],
      SiteId: '1'
    };
    const accessToken = localStorage.get('accessToken');
    const SiteId = localStorage.get('currentSite');
    const deviceTypeObject = {
      method: 'POST',
      url: `${API_TRENDS.LIST}?SiteId=${SiteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      json: payload
    };
    axios(deviceTypeObject)
      .then((response) => {
        // let { option } = this.state;
        let json = response.data;
        let legendData = json.map((item) => item.Description);
        let xAxisData = json.map((item) => item.DateTime);
        let seriesData =
          legendData &&
          Array.isArray(legendData) &&
          legendData.map((legend) => {
            let dataObject =
              json &&
              Array.isArray(json) &&
              json.map((e) => {
                if (e.Description === legend) {
                  return e.Value;
                }
                return {};
              });
            return {
              name: legend,
              type: 'line',
              stack: 'Total',
              json: dataObject
            };
          });

        let optionData = {
          ...option,
          legend: {
            json: legendData
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            json: xAxisData
          },
          series: seriesData
        };
        setOption(optionData);
      })
      .catch(function () { });
  };

  const getData = async () => {
    requestCheck.current = false;
    let json = [];
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (json && Array.isArray(json) && json.length > 0) {
        let columnsData = await tableTranslation(json, translationCache);
        let cardsList = columnsData.map((column) => {
          // if (_.isString(column.Value) === true && _.isString(column.Description) === true) {
          return {
            title: column.Description,
            value: column.Value
          };
          // } else {
          // setErrorInAPI(true);
          // }
          // return {};
        });
        setCardsList(cardsList);
      } else {
        setCardsList([]);
        setRefreshDateTime(moment());
      }
    }
  };

  let colors = [];
  if (
    graphprops &&
    graphprops[graphprops.graph] &&
    graphprops[graphprops.graph].colors &&
    graphprops[graphprops.graph].colors.length > 0
  ) {
    colors = {
      ...(graphprops[graphprops.graph].colors &&
        Array.isArray(graphprops[graphprops.graph].colors)
        ? graphprops[graphprops.graph].colors
        : []),
      ...colors
    };
  }
  return (
    <>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {last30Records ? (
        <Modal
          title="Last 30mins Data"
          open={last30Records}
          onCancel={() => {
            setLast30Records(false);
          }}
        >
          <ReactEcharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            className="react_for_echarts"
          />
        </Modal>
      ) : null}
      {graphprops &&
        graphprops[graphprops.graph] &&
        graphprops[graphprops.graph].show30minsData &&
        graphprops[graphprops.graph].show30minsData === 'true' ? (
        <Button
          type="primary"
          style={{ float: 'right' }}
          onClick={() => {
            setLast30Records(true);
          }}
        >
          Show last 30mins Data
        </Button>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <div style={{ padding: '10px' }}>
          {props &&
            props.graphprops &&
            props.graphprops[graphprops.graph] &&
            props.graphprops[graphprops.graph].viewType === 'listOfItems' ? (
            <List
              itemLayout="horizontal"
              dataSource={cardsList}
              renderItem={(item, index) => {
                console.log(colors);
                
                let cardTextColor = colors[index] || 'black';
                return <List.Item>
                  <List.Item.Meta
                    style={{ marginLeft: '30px' }}
                    title={
                      <span style={{ color: cardTextColor }}>{item.title}</span>
                    }
                  />
                  <Row>
                    <div style={{ color: cardTextColor }}>{item.value}</div>
                  </Row>
                </List.Item>;
              }}
            />
          ) : null}

          {props &&
            props.graphprops &&
            props.graphprops[graphprops.graph] &&
            props.graphprops[graphprops.graph].viewType === 'listOfCards' ? (
            <List
              grid={{
                gutter: 10,
                column: props.graphprops[graphprops.graph].numberOfColumns
                  ? props.graphprops[graphprops.graph].numberOfColumns
                  : 3
              }}
              dataSource={cardsList}
              style={{
                textAlign: 'center',
                textColor: '#fff !important',
                fontSize: '3.5em'
              }}
              renderItem={(item, index) => (
                <List.Item>
                  <Card
                    className="counterCard"
                    title={item.title}
                    style={{ backgroundColor: colors[index] || 'black', fontSize: '1.5em' }}
                  >
                    {graphprops &&
                      graphprops[graphprops.graph] &&
                      graphprops[graphprops.graph].displayType &&
                      graphprops[graphprops.graph].displayType === 'Image' ? (
                      <img
                        src={item.value}
                        type="image"
                        alt=""
                        style={{ marginTop: '8px', height: '222px' }}
                      />
                    ) : (
                      item.value
                    )}
                  </Card>
                </List.Item>
              )}
            />
          ) : null}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(CardsList);
